<template>
    <div v-show="!props.hide">
        <sp-form
            class="mobile-general-form-textarea"
            :class="[
                `uuid-${config.uuid}`,
                {
                    'preview-text': globalModel.preview,
                    'disable-opacity': notChanged,
                    'notice-form-preview': globalModel.noticeFormPreview
                }
            ]"
            ref="elForm"
            v-show="!props.hide"
            :model="formModel"
            :rules="rules"
            label-position="top"
        >
            <sp-form-item
                v-if="!globalModel.preview"
                prop="inputValue"
                :label="i18nLabel"
            >
                <sub-title :errorMsg="errorMsg"></sub-title>
                <sp-textarea
                    v-model="formModel.inputValue"
                    @input="onInput"
                    :style="textareaStyle"
                    :maxlength="+props.max"
                    :placeholder="i18n(props.placeholder)"
                    :disabled="notChanged"
                ></sp-textarea>
            </sp-form-item>
            <sp-form-item prop="inputValue" v-else>
                <!-- 预览时的效果 -->
                <preview-text
                    :labelText="i18nLabel"
                    :textDesc="formModel.inputValue"
                ></preview-text>
            </sp-form-item>
        </sp-form>
        <sub-title class="mt16 plr19 error-right" v-if="lastShowRejectTip(i18nLabel)" :errorMsg="outputError(i18nLabel)"></sub-title>
    </div>
</template>
<script>
import { Form, FormItem, Textarea } from '@ks/sharp-ui';
import ComponentBase from '../component-base';
import { component } from './props';
import PreviewText from '../component-base/common/preview-text';
import SubTitle from '../component-base/common/sub-title';

export default {
    name: component,
    components: {
        SpForm: Form,
        SpFormItem: FormItem,
        SpTextarea: Textarea,
        PreviewText,
        SubTitle,
    },
    extends: ComponentBase,
    data() {
        return {
            formModel: {
                inputValue: '',
            },
            textareaStyle: {
                // borderTop: `${1 / window.devicePixelRatio}px solid #e0e0e0`,
                // borderBottom: `${1 / window.devicePixelRatio}px solid #e0e0e0`,
            },
            errorMsg: '',
        };
    },
    computed: {
        rules() {
            const rules = [];
            // 最小长度
            if (this.props.min) {
                rules.push({
                    type: 'string',
                    min: +this.props.min,
                    message: this.i18n(this.props.errMin, this.i18nLabel, this.props.min)
                        || `${this.i18nLabel}长度不能小于${this.props.min}`,
                });
            }
            // 最大长度
            if (this.props.max) {
                rules.push({
                    type: 'string',
                    max: +this.props.max,
                    message: this.i18n(this.props.errMax, this.i18nLabel, this.props.max)
                        || `${this.i18nLabel}长度不能大于${this.props.max}`,
                });
            }
            // 正则表达式
            if (this.props.pattern) {
                try {
                    const regExp = new RegExp(this.props.pattern);
                    rules.push({
                        pattern: regExp,
                        message: this.i18n(this.props.errPattern, this.i18nLabel)
                            || `${this.i18nLabel}格式不合规`,
                    });
                } catch (e) {
                    this.warn(e);
                }
            }
            return {
                inputValue: this.composeRules(this.props, { otherRules: rules }),
            };
        },
    },
    methods: {
        onInput($event) {
            this.onInputValueChange($event);
            this.$emit('user-input');
        },
        onInputValueChange() {
            const res = this.setSelfFormDataValue(this.formModel.inputValue);
            if (res) {
                // 数据修改成功，抛出change事件，触发依赖
                this.$emit('change');
            }
        },
        /**
         * 以下是组件公共方法的实现
         */
        dataChangeHandler() {
            const newValue = this.getSelfFormDataValue();
            if (typeof newValue === 'undefined') {
                // 默认值逻辑
                this.formModel.inputValue = '';
                this.onInputValueChange();
                // this.validate();
                return;
            }

            if (this.formModel.inputValue !== newValue) {
                this.formModel.inputValue = newValue;
                // 数据被动修改同样抛出change事件
                this.$emit('change');
                // this.validate();
            }
        },
        async validate() {
            if (this.skipValidate()) {
                return true;
            }
            const promise = new Promise((resolve, reject) => {
                this.$refs.elForm.validate((valid, invalidFields) => {
                    valid ? resolve(valid) : reject(invalidFields);
                });
            });
            try {
                return await promise;
            } catch (e) {
                this.errorMsg = e.inputValue[0].message;
                this.validateFailureHandler(e.inputValue[0].message);
                return false;
            }
        },
        clearValidate() {
            this.errorMsg = '';
            this.$refs.elForm && this.$refs.elForm.clearValidate();
        },
    },
};
</script>
<style lang="less" scoped>
@import '../../style.less';
.mobile-general-form-textarea {
    /deep/ .sp-form-item__error {
        // top: 0 !important;
        // left: 0 !important;
        display: none !important;
    }
}
</style>